/**
 * Build-time feature flag for Stripe marketplace payments.
 * Set REACT_APP_STRIPE_ENABLED=true in Dev/Staging; false in Production until go-live.
 */
export const isStripeFeatureEnabled = (): boolean =>
  String(process.env.REACT_APP_STRIPE_ENABLED || 'false').toLowerCase() === 'true';
